import tacklebox from "tacklebox";

import { Page } from '@/js/Page.js';


function Expectation(id, title) {
    this.id = id;
    this.title = title;
}

function FreewordPage() {
    Page.call(this, "Freeword", "フリーワード");
    this.interviewId = "";
    this.userinput = "";
    this.selecteds = [];
    this.histories = [];
    this.debug = "";
    this.expectations = [];
    this.selecteds = [];
}
tacklebox.design.extend(FreewordPage, Page);
FreewordPage.prototype.isSelected = function () {
    return this.selecteds.length > 0;
};
FreewordPage.prototype.select = function (expectation_id) {
    this.selecteds = [expectation_id];
};
FreewordPage.prototype.cancel = function () {
    this.selecteds = [];
    this.expectations = [];
};

FreewordPage.prototype._onInitialize = function () {
    //
};

FreewordPage.prototype.search = function () {
    console.log(this.userinput);
    const self = this;
    this.expectations = [];
    if (this.userinput == "") {
        this.expectations = [];
    } else {
        fetch(process.env.VUE_APP_HACHIWARE + "/suggests/freeword?word=" + this.userinput, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then((response) => response.json())
            .then((json) => {
                console.log(json);
                this.debug = json;
                if (json?.data) {
                    if (json.data.length == 0) {
                        self.expectations = [];
                    } else {
                        for (let i in json.data) {
                            self.expectations.push(
                                new Expectation(
                                    json.data[i].id,
                                    json.data[i].expectation,
                                )
                            );

                        }


                    }
                } else {
                    self.expectations = [];
                }
            })
            .catch((error) => {
                tacklebox.e(error)
            });

    }

};

FreewordPage.prototype.startInterview = function (callback = (interview_id) => { tacklebox.d(interview_id) }) {
    let rbody = {
        "id": this.selecteds[0],
        "requires": [
        ],
        "ignores": [
        ],
        "session": "x"
    };

    for (let i in this.selecteds) {
        rbody.requires.push(this.selecteds[i]);
    }

    fetch(process.env.VUE_APP_HACHIWARE + "/interviews/entry/freeword", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(rbody)
    })
        .then((response) => response.json())
        .then((json) => {
            console.log(json);
            if (callback) {
                callback(json.data.id);
            }
        })
        .catch((error) => {
            tacklebox.e(error)
            if (callback) {
                callback(null);
            }
        });
};

export { FreewordPage }
